<div class="footer">
	<div class="container">
		<div class="">
			<div class="column">

				<div class="col-1-container">
					<img alt="" src="./assets/images/lollipapp_logo_footer.png" class="footer-logo" alt="LollipApp Logo">

					<div>
						{{getString('becauseWeLoveApps')}}
					</div>
					<br>
					<p><small>{{getString('allRightsReserved')}}</small><br/>
					<small class="version" style="font-size: smaller; text-align: left; cursor: pointer;" (click)="sendLogToServer()">{{ version }}</small></p>

				</div>
			</div>

			<div class="column">
				<div class="footer-title blue-underlined">{{getString('information')}}</div>
				<div class="underline-blue"></div>
				<ul>
					<li><a href="https://www.cheapcharts.com/blog" target="_blank">Blog</a></li>
					<li><a [routerLink]="'/' + getCountry() + '/' + getString('imprintUrl')">{{getString('imprint')}}</a></li>
					<li><a [routerLink]="'/' + getCountry() + '/' + getString('disclaimerUrl')">{{getString('disclaimer')}}</a></li>
					<li><a href="https://www.cheapcharts.com/download/presskit.zip" target="_blank">{{getString('pressKit')}}</a></li>
					<li><a href="https://app.cheapcharts.com" target="_blank">{{getString('cheapchartsApp')}}</a></li>
					<li><a href="https://games.cheapcharts.info" target="_blank">{{getString('cheapchartsGames')}}</a></li>
					<li><a [routerLink]="'/' + getCountry() + '/' + getString('contactUrl')">{{getString('contact')}}</a></li>
				</ul>
			</div>

			<div class="column">
				<div class="footer-title blue-underlined">{{getString('deals')}}</div>
				<div class="underline-blue"></div>
				<ul>
					<li><a [routerLink]="'/' + getCountry() + '/' + getString('itunesMovieDealsUrl')">{{getString('itunesMovieDeals')}}</a></li>
					<li><a [routerLink]="'/' + getCountry() + '/' + getString('primeVideoDealsUrl')">{{getString('primeVideoDeals')}}</a></li>
					<li *ngIf="getCountry() == 'us'"><a [routerLink]="'/' + getCountry() + '/' + getString('vuduMovieDealsUrl')">{{getString('vuduMovieDeals')}}</a></li>
					<li><a [routerLink]="'/' + getCountry() + '/' + getString('itunesMovies4KUrl')">{{getString('itunesMovieDeals4K')}}</a></li>
					<li><a [routerLink]="'/' + getCountry() + '/' + getString('cardDealsUrl')">{{getString('giftCardDeals')}}</a></li>
					<li><a [routerLink]="'/' + getCountry() + '/itunes/' + getString('moviesUrl') + '/' + getString('movie3dUrl')">{{getString('itunes')}} {{getString('movies3D')}}</a></li>
				</ul>
			</div>

			<div class="column">
				<div class="footer-title blue-underlined">{{getString('onsale2')}}</div>
				<div class="underline-blue"></div>
				<ul>
					<li><a [routerLink]="'/' + getCountry() + '/itunes/' + getString('moviesUrl') + '/' + getString('onSaleUrl')">{{getString('itunesMoviesOnSale')}}</a></li>
					<li><a [routerLink]="'/' + getCountry() + '/itunes/' + getString('seasonsUrl') + '/' + getString('onSaleUrl')">{{getString('itunesSeasonsOnSale')}}</a></li>
					<li *ngIf="showAmazon() && (getCountry() == 'us' || getCountry() == 'de')"><a [routerLink]="'/' + getCountry() + '/amazon/' + getString('moviesUrl') + '/' + getString('onSaleUrl')">{{getString('amazonMoviesOnSale')}}</a></li>
					<li *ngIf="showAmazon() && (getCountry() == 'us' || getCountry() == 'de')"><a [routerLink]="'/' + getCountry() + '/amazon/' + getString('seasonsUrl') + '/' + getString('onSaleUrl')">{{getString('amazonSeasonsOnSale')}}</a></li>
					<li *ngIf="getCountry() == 'us'"><a [routerLink]="'/' + getCountry() + '/vudu/' + getString('moviesUrl') + '/' + getString('onSaleUrl')">{{getString('vuduMoviesOnSale')}}</a></li>
					<li *ngIf="getCountry() == 'us'"><a [routerLink]="'/' + getCountry() + '/google-play/' + getString('moviesUrl') + '/' + getString('onSaleUrl')">{{getString('googlePlayMoviesOnSale')}}</a></li>
				</ul>
			</div>

			<div class="column">
				<div class="footer-title blue-underlined">{{getString('getSocial')}}</div>
				<div class="underline-blue"></div>
				<ul class="list-inline">
					<li>
						<a href="https://www.facebook.com/www.cheapcharts.de" target="_blank"><span class="facebook-hover social-icon social-slide"></span></a>
					</li>
					<li>
						<a href="https://twitter.com/CheapCharts_US" target="_blank"><span class="twitter-hover social-icon social-slide"></span></a>
					</li>
					<li>
						<a href="https://instagram.com/lollipapp" target="_blank"><span class="instagram-hover social-icon social-slide"></span></a>
					</li>
				</ul>
			</div>

		</div>
	</div>
</div>
